import { createRender } from 'svelte-headless-table'
import Tooltip from '../atoms/Tooltip.svelte'
import { TooltipPlacements } from '$types/enums'

export function renderTooltip(
	msg: string,
	iconSrc: string,
	placement: TooltipPlacements = TooltipPlacements.RIGHT,
	iconSize: string = '16px',
	isHtml: boolean = true
) {
	return createRender(Tooltip, {
		msg: msg,
		ttipIconImage: iconSrc,
		ttipIconWidth: iconSize,
		ttipIconHeight: iconSize,
		placementTtip: placement,
		isHtml: isHtml
	})
}

export function createCol(header: string, accessor: string, options: any = null) {
	return { header: header, accessor: accessor, ...options }
}
